module.exports = __webpack_public_path__ + "74bf0f09e81cb0b245130d0d518221d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-320-7.jpg
// module id = 439
// module chunks = 0